module.exports = __webpack_public_path__ + "static/media/grip-lines-vertical.ebdc494f.svg";